module.exports = __webpack_public_path__ + "static/media/care4.0ffdbdf6.webp";